import {Component, EventEmitter, Input, OnChanges, OnInit, Output, SimpleChanges} from '@angular/core';
import {MatDialog, MatDialogRef} from '@angular/material/dialog';
import {
    IAccommodation,
    IBookingPropertyDescription,
    IGetBookingsStayResponse,
    IGetBookingsStayVendorMessage, IOriginalCurrency,
    IPrice,
    IPriceDetail,
    IProperty as IGetBookingProperty,
    ISectorStay,
    IService,
    ITraveller,
    IXId,
    XSellLocationEnum,
} from 'libraries/service/resources/booking/interfaces/IGetBookings';
import {
    IHotelInformations,
    PropertyDescriptionComponent
} from './components/property-description/property-description.component';
import {ICurrencies, IGetPropertyResponse, IProperty} from 'libraries/service/resources/hotel/ISearchResponse';
import {INotification, NotificationType} from 'libraries/interfaces/INotification';
import {ILoader} from 'libraries/component/loader/ILoader';
import {Yii} from 'libraries/interfaces/Yii';
import {ILabels} from 'libraries/interfaces/ILabels';
import {ErrorTracingService} from "libraries/service/error-tracing/error-tracing.service";
import {ICost, IPenalty} from 'libraries/service/resources/hotel/IResourceHotel';
import {IAirTotal} from 'libraries/service/resources/model/search/air/IAirTotal';
import {ImportantInformationComponent} from "./components/important-information/important-information.component";
import {
    ICancellationKeyword
} from "libraries/hotel/components/cancellation-conditions/cancellation-conditions.interface";
import {PricePerRoomMappingService} from "./components/price-per-room-modale/price-per-room-mapping.service";
import {IPricePerRoomData, PricePerRoomComponent} from "./components/price-per-room-modale/price-per-room-component";
import {IProperty as IQuoteProperty, IQuote, IQuoteSupplement} from "libraries/hotel/models/quote";
import {IResortFeeDetail} from "libraries/service/resources/model/search/IBooking";
import {BtnStyleTypes, Size} from "libraries/ui_button/btn.component";
import {
    CancellationConditionsService
} from "libraries/hotel/components/cancellation-conditions/services/cancellation-conditions.service";
import {EXRateType, ITotal} from 'libraries/interfaces/ITotal';
import {finalize, map} from 'rxjs/operators';
import {IAlternative} from 'libraries/hotel/models/hotel';
import {PropertyResourceService} from "libraries/service/resources/hotel/property-resource.service";
import {
    PropertyDescriptionService
} from "libraries/component/booking-information/components/sectors/components/sectors-stay/property-description.service";
import {LabelService} from 'libraries/service/label/label.service';
import {faBed, IconDefinition} from "@fortawesome/free-solid-svg-icons";
import {LoaderModaleComponent} from "libraries/component/loader/loader-modale.component";
import {forkJoin, Observable, of} from "rxjs";
import _cloneDeep from "lodash-es/cloneDeep";
import {EStayPermissions} from "libraries/enums/e-stay-permissions";
import {DescriptionHelperService} from "libraries/service/description-helper/description-helper.service";
import {IDescriptionObject} from "libraries/hotel/models/details";
import {PermissionResourceService} from "../../../../../../../service/resources/permission/permissionResource.service";
import {IHotelQuoteDetail} from "../../../../../../../service/resources/hotel/hotel-quotation";
import {
    GetMainCurrencyService,
    ICurrencyConfig,
    IMainAndAsidePrices, IMainAndAsidePricesDetail
} from "../../../../../../../service/get-main-currency/get-main-currency.service";
import {IConfigSharedHotel} from "../../../../../../../hotel/models/config-shared-hotel";
import {
    ConfigSharedHotelService
} from "../../../../../../../service/resources/configuration/config-shared-hotel.service";
import {ICurrency} from "../../../../../../../service/resources/model/search/ICurrency";

export interface IRoomDetails extends IPriceDetail {
    name?: string;
    xCode?: string;
}

interface IData {
    accommodation: IAccommodation;
    traveller?: ITraveller[];
    room?: IRoomDetails;
    supplement?: IRoomDetails;
}

interface IHostInformations {
    hostName: string;
    hostPropertySyscode: string;
}

@Component({
    selector: 'sector-stay-details',
    templateUrl: 'sector-stay-details.component.html',
    styleUrls: ['sector-stay-details.component.scss']
})
export class SectorStayDetailsComponent implements OnInit, OnChanges {
    //extends ExternalServiceDisplayGenericComponent
    @Input()
    public sector: ISectorStay;
    @Input()
    public classBtnList: string;

    @Input()
    public booking: Partial<IGetBookingsStayResponse>;
    @Input()
    public showIcon: boolean;
    @Input()
    public quote: IQuote;
    @Input()
    public quoteProperty: IQuoteProperty;
    @Input()
    public storedProperties: { [key: string]: IProperty };
    @Input()
    public priceQuote: IQuote;

    @Input()
    public quotePropertyAlternatives: IAlternative[];

    @Input()
    public fallbackName: string;

    @Output()
    public readonly onGetProperty: EventEmitter<IProperty> = new EventEmitter<IProperty>();

    public currentAlternatives: IAlternative[];
    public property: IProperty | IGetBookingProperty;
    public hasDetails: boolean = false;
    public rating: number | undefined = undefined;
    public hasImportantInformation: boolean;
    public btnSize: typeof Size = Size;
    public mainCurrency: string;

    public notification: INotification = {
        active: false,
        type: NotificationType.Warning
    };
    public noBookingNotification: INotification = {
        active: false,
        type: NotificationType.Warning,
        message: Yii.t('wui-watabi-js', 'Un problème a été rencontré lors de la récupération complète du dossier. Merci de rafraîchir la page.')
    };
    public refreshBtnType: BtnStyleTypes = BtnStyleTypes.actionLink;

    public loader: ILoader = {
        active: false,
        message: Yii.t('wui-shared-js', "Chargement des informations de l'hôtel"),
        type: 'inline'
    };

    public labels: ILabels = {
        moreDetails: Yii.t('wui-shared-js', 'Détails'),
        noRoomDefined: Yii.t('wui-shared-js', 'Aucune chambre pour cette étape'),
        webSite: Yii.t('wui-shared-js', 'Site internet'),
        importantInformation: Yii.t('wui-shared-js', 'Informations importantes'),
        helpDesk: Yii.t('wui-shared-js', 'Support Client : '),
        pricePerRoom: Yii.t('wui-shared-js', 'Afficher le détail des prix'),
        refresh: Yii.t('wui-shared-js', 'Rafraîchir'),
        costPrice: Yii.t('wui-shared-js', 'Prix d\'achat'),
        retailPrice: Yii.t('wui-shared-js', 'Prix de vente'),
    };

    public total: ITotal;
    public totalRetail: ITotal;

    public costTotal: IMainAndAsidePricesDetail;
    public retailTotal: IMainAndAsidePricesDetail;
    public quoteCurrencyKeys: string[] = [];

    public accommodations: IData[];
    public services: { [key: string]: IService };

    public cancellationPenalties: IPenalty[];
    public cancellationBasePrice: ICost;
    public cancellationPenaltiesByAccomodation: { [xId: string]: IPenalty[] } = {};
    public basePricesByAccomodation: { [xId: string]: ICost } = {};
    public cancellationPenaltiesByAccomodationFromQuote: { [xId: string]: IPenalty[] };

    public helpDesk: string;
    public sellingLink: IGetBookingsStayVendorMessage;

    public totalLocal: IPriceDetail;
    public totalRetailLocal: ITotal;

    public cancellationKeyword: ICancellationKeyword[];
    public canDisplayImportantInformationLink: boolean = false;
    public additionalTotal: ITotal;
    public additionalTotalRetail: ITotal;
    public displayableDescriptions: (IDescriptionObject | IBookingPropertyDescription)[] = [];

    public iconBed: IconDefinition = faBed;

    public showCostPrice: boolean = false;
    public showRetailPrice: boolean = false;

    constructor(
        private readonly propertyResourceService: PropertyResourceService,
        public dialog: MatDialog,
        private readonly errorTracingService: ErrorTracingService,
        private readonly pricePerRoomMappingService: PricePerRoomMappingService,
        private readonly cancellationConditionsService: CancellationConditionsService,
        private readonly propertyDescriptionService: PropertyDescriptionService,
        private readonly descriptionHelperService: DescriptionHelperService,
        private readonly labelService: LabelService,
        private readonly permissionResource: PermissionResourceService,
        private readonly getMainCurrencyService: GetMainCurrencyService,
        private configSharedHotelService: ConfigSharedHotelService,
    ) {
    }

    public ngOnChanges(changes: SimpleChanges): void {
        if (changes?.booking?.currentValue) {
            const booking: IGetBookingsStayResponse = _cloneDeep(changes.booking.currentValue);
            this.accommodations = this.getAccommodationsDetails(_cloneDeep(booking));
            this.initServices(_cloneDeep(booking));

            this.cancellationPenalties = this.cancellationConditionsService.getPenaltiesForAccomodation(_cloneDeep(booking), undefined, this.showCostPrice, this.showRetailPrice);
            this.cancellationBasePrice = (_cloneDeep(booking).total || [])
                .filter((total: IAirTotal): boolean => total.xType === EXRateType.cost)
                .map((total: IAirTotal) => ({[total.currency]: total.value}))
                .find((): boolean => true);

            this.cancellationPenaltiesByAccomodation = this.cancellationConditionsService.createPenaltiesByAccomodationFromRules(_cloneDeep(booking), this.showCostPrice, this.showRetailPrice);
            if(this.quote && this.quote.detail){
                const isRetailOnQuotePenalties: boolean =  Object.values(this.quote.detail)
                    .some((detail: IHotelQuoteDetail): boolean =>
                        Object.values(detail.room.penalty)
                            .some((penalty: IPenalty):boolean =>
                                Boolean(penalty.total?.retail)));

                if(isRetailOnQuotePenalties){
                    this.cancellationPenaltiesByAccomodationFromQuote = this.cancellationConditionsService.createPenaltiesByAccomodationFromQuoteDetails(this.quote.detail, this.showCostPrice, this.showRetailPrice);
                }
            }

            this.basePricesByAccomodation = createBasePriceByAccomodation(_cloneDeep(booking));

            this.hasImportantInformation = Boolean(booking.property?.length > 0 && booking.property[0].description?.length > 0);

            this.helpDesk = booking.vendor?.telephone?.xScope === "HelpDesk" ?
                booking.vendor.telephone.text :
                undefined;

            this.sellingLink = this.booking.vendor ? this.booking.vendor.message : undefined;

            this.cancellationKeyword = this.cancellationConditionsService.extractCancellationKeyword(_cloneDeep(booking).price);

            this.computeImportantInformations(_cloneDeep(booking));
        }
    }

    public ngOnInit(): void {
        this.permissionResource.getPermissionsStartingWith(['shared', 'stay', 'price']).subscribe((permissions: Set<string>): void => {
            if(permissions){
                this.getTotalAndTotalRetailOnQuote(permissions);
            }
            this.currentAlternatives = this.quoteProperty ? this.quoteProperty.alternatives : this.quotePropertyAlternatives;

            this.loader.active = true;
            if(this.booking){
                this.computeImportantInformations(_cloneDeep(this.booking));
                const totalFound: IPrice[] = _cloneDeep(this.booking.price.filter((price: IPrice): boolean => price.xTarget === 'total'));
                const totalCostFound: IPrice = this.showCostPrice ? totalFound.find((price: IPrice): boolean => price.xType === EXRateType.cost) ?? totalFound[0] : undefined;
                const totalRetailFound: IPrice = this.showRetailPrice && totalFound.find((price: IPrice): boolean => price.xType === EXRateType.retail);
                if(totalCostFound){
                    this.computeBookingTotal(totalCostFound, false);
                }
                if(totalRetailFound){
                    this.computeBookingTotal(totalRetailFound, true);
                }
            }

            if (this.quoteProperty) {
                this.property = {
                    ...this.quoteProperty as unknown as IProperty,
                    descriptions: this.booking.property[0].description,
                };
                this.hasDetails = true;
                this.loader.active = false;
            } else {
                this.getHotelProperty();
            }
        });
    }

    public refresh(): void {
        document.location.reload();
    }

    public getHotelProperty(): void {
        const hostInformations: IHostInformations = this.setHostInformations();

        this.setPropertyFromResource(hostInformations.hostName, hostInformations.hostPropertySyscode);

    }

    public showDetails(): void {
        const hostInformations: IHostInformations = this.setHostInformations();
        const loaderDialog: MatDialogRef<LoaderModaleComponent> = this.dialog.open(LoaderModaleComponent, {
            width: '900px',
            maxHeight: '80%',
        });
        this.getHostProperty(hostInformations.hostName, hostInformations.hostPropertySyscode)
            .subscribe({
                next: (propertyResponse: IGetPropertyResponse): void => {
                    loaderDialog.close();
                    this.displayPropertyDescriptionModal(propertyResponse);
                },
                error: (err => {
                    loaderDialog.close();
                    this.displayPropertyDescriptionModal();
                })
            });
    }

    private displayPropertyDescriptionModal(propertyResponse: IGetPropertyResponse = null): void {
        if (propertyResponse?.property) {
            const hotelInformation: IHotelInformations = {
                property: propertyResponse.property as IProperty,
                mealplan: {
                    // Les valeur de name et de mealplan se trouve à la racine de service
                    name: this.booking.service ? this.services.mealplan.name : null,
                    code: this.booking.service ? this.services.mealplan.mealplan.xCode : null
                }
            };

            hotelInformation.property.dateLastCancellationWithoutPenalty = this.quote ? this.quote.dateLastCancellationWithoutPenalty : null;
            if (this.currentAlternatives) {
                hotelInformation.property.alternatives = [...hotelInformation.property.alternatives, ...this.currentAlternatives];
            }
            this.onGetProperty.emit(propertyResponse.property);
            this.dialog.open(PropertyDescriptionComponent, {
                width: '900px',
                maxHeight: '80%',
                data: {
                    hotelInformation,
                    bookingHost: this.booking.host,
                }
            })
                .afterClosed()
                .subscribe((property: IProperty): void => {
                    this.onGetProperty.emit(property);
                });
        } else {
            const hotelInformation: IHotelInformations = {
                property: this.property as IProperty,
                mealplan: {
                    // Les valeur de name et de mealplan se trouve à la racine de service
                    name: this.booking.service ? this.services.mealplan.name : null,
                    code: this.booking.service ? this.services.mealplan.mealplan.xCode : null
                }
            };
            hotelInformation.property.dateLastCancellationWithoutPenalty = this.quote ? this.quote.dateLastCancellationWithoutPenalty : null;
            if (this.currentAlternatives) {
                hotelInformation.property.alternatives = this.currentAlternatives;
            }
            this.dialog.open(PropertyDescriptionComponent, {
                width: '900px',
                maxHeight: '80%',
                data: {
                    hotelInformation,
                    bookingHost: this.booking.host
                }
            })
                .afterClosed()
                .subscribe((property: IProperty): void => {
                    this.onGetProperty.emit(property);
                });
        }
    }

    public showPricePerRoom(): void {

        const selectedSourceQuote: IQuote = this.priceQuote || this.quote;

        const data: IPricePerRoomData = {
            headers: this.pricePerRoomMappingService.getHeaders(selectedSourceQuote.detail),
            total: this.pricePerRoomMappingService.getTotalRows(
                selectedSourceQuote.detail,
                (selectedSourceQuote.supplement) as IQuoteSupplement[],
                selectedSourceQuote.total,
                Object.keys(selectedSourceQuote.total.cost)[0]),
            local: this.pricePerRoomMappingService.getLocalRows(
                selectedSourceQuote.detail,
                (selectedSourceQuote.resortFees) as IResortFeeDetail[],
                Object.keys(selectedSourceQuote.total.cost)[0]
            ),
            roomIds: this.pricePerRoomMappingService.getRoomsIds(selectedSourceQuote.detail),
            colsName: this.pricePerRoomMappingService.getColsNames(selectedSourceQuote.detail),
            canShowCost: this.showCostPrice,
            canShowRetail: this.showRetailPrice,
        };


        this.dialog.open(PricePerRoomComponent, {
            maxWidth: '900px',
            maxHeight: '80%',
            data
        });
    }

    public showImportantInformation(): void {
        const data: (IDescriptionObject | IBookingPropertyDescription)[] = this.displayableDescriptions;
        this.displayableDescriptions = this.descriptionHelperService.replaceHostWithAlias(this.displayableDescriptions);

        this.dialog.open(ImportantInformationComponent, {
            width: '900px',
            maxHeight: '80%',
            data
        });
    }

    public openWebSite(url: string): void {
        window.open(url, "_blank");
    }

    public permissions: typeof EStayPermissions = EStayPermissions;

    private getTotalAndTotalRetailOnQuote(permissions: Set<string>): void {
        this.showCostPrice = permissions.has('shared.stay.price.cost.show');
        this.showRetailPrice = permissions.has('shared.stay.price.retail.show');

        if((this.showCostPrice || this.showRetailPrice) && (this.quote && this.quote?.total)){
            this.configSharedHotelService.getConfiguration()
                .subscribe({
                    next: (sharedHotelConfig: IConfigSharedHotel) : void => {
                        if (this.showCostPrice) {
                            this.computeTotalWithConversion(sharedHotelConfig);
                        }

                        if (this.quote.total.retail && this.showRetailPrice) {
                            this.computeTotalWithConversion(sharedHotelConfig, true);
                        }

                        this.accommodations = this.getAccommodationsDetails(_cloneDeep(this.booking as IGetBookingsStayResponse));
                    }
                });
        }
    }

    private computeTotalWithConversion(sharedHotelConfig: IConfigSharedHotel, isRetail: boolean = false): void {
        let costCurrencies: ICurrencies = {};
        Object.keys(isRetail ? this.quote.total.retail : this.quote.total.cost).forEach((key: string):void => {
            costCurrencies = {
                ...costCurrencies,
                [key] : {code: key, decimals: 2}
            };
        });

        const config: ICurrencyConfig = this.getMainCurrencyService.getCurrencyConfig(isRetail ? this.quote.total.retail : this.quote.total.cost,
            costCurrencies,
            sharedHotelConfig);

        const prices: IMainAndAsidePrices = this.getMainCurrencyService.getMainAndAsidePrice(isRetail ? this.quote.total.retail : this.quote.total.cost,
            costCurrencies,
            config);

        if(!isRetail){
            this.mainCurrency = prices.mainPrice.currency;
        }

        let total : IMainAndAsidePricesDetail = {
            mainPrice: {
                amount: prices.mainPrice.amount,
                currency: prices.mainPrice.currency,
                value: prices.mainPrice.amount * 100,
                decimals: 2
            }
        };

        if(prices.asidePrice){
            total = {
                ...total,
                asidePrice: {
                    amount: prices.asidePrice.amount,
                    currency: prices.asidePrice.currency,
                    value: prices.asidePrice.amount * 100
                }
            };
        }

        isRetail ? this.retailTotal = total : this.costTotal = total;
    }

    private computeBookingTotal(totalFound: IPrice, isRetail: boolean = false): void {
        const {total}: { total?: ITotal | ITotal[] } = totalFound.total;
        const emptyMerchantPriceDetail: IPriceDetail = {
            amount: null,
            unitAmount: null,
            currency: null,
            traveller: null,
            value: null,
            unitValue: null,
            decimals: null,
        };

        const totalLocal: ITotal = _cloneDeep(totalFound).detail?.supplement?.length ?
            totalFound.detail.supplement
                .filter((supplement: IPriceDetail): boolean => supplement.xSellLocation === XSellLocationEnum.local)
                .reduce((merchantTotalPrice: IPriceDetail, currentSupplement: IPriceDetail, index: number): IPriceDetail => {
                    if (index === 0) {
                        return currentSupplement;
                    }
                    merchantTotalPrice.amount = Number(currentSupplement.amount) + Number(merchantTotalPrice.amount);
                    merchantTotalPrice.value = Number(currentSupplement.value) + Number(merchantTotalPrice.value);
                    if (merchantTotalPrice.originalCurrency) {
                        merchantTotalPrice.originalCurrency.amount = Number(currentSupplement.originalCurrency.amount) + Number(merchantTotalPrice.originalCurrency.amount);
                        merchantTotalPrice.originalCurrency.value = Number(currentSupplement.originalCurrency.value) + Number(merchantTotalPrice.originalCurrency.value);
                    }
                    return merchantTotalPrice;
                }, emptyMerchantPriceDetail)
            : undefined;

        const globalTotal: ITotal = Array.isArray(total)
            ? total.reduce((value1: ITotal, value2: ITotal): ITotal => {
                const amount: number = (value1.amount || value2.amount) + (value2.amount || 0);

                return {
                    amount,
                    currency: value1.currency,
                    decimals: value1.decimals,
                    value: amount * Math.pow(10, value1.decimals),
                };
            })
            : total;
        const additionalTotal: ITotal = totalFound.additionalTotal;

        if(isRetail){
            this.totalLocal = totalLocal;
            this.totalRetailLocal = totalLocal;
            this.totalRetail = globalTotal;
            this.additionalTotalRetail = additionalTotal;
        } else {
            this.totalLocal = totalLocal;
            this.total = globalTotal;
            this.mainCurrency = this.total.currency;
            this.additionalTotal = additionalTotal;
        }
    }

    private displayErrorOnGetProperty(error: Error): void {
        if (this.quoteProperty) {
            this.property = this.quoteProperty as unknown as IProperty;
        } else {
            this.property = this.booking.property.length === 1 ?
                this.booking.property[0] :
                (this.booking.property || [])
                    .find((property) => property.xId === this.sector.property.xId);
        }

        this.loader.active = false;
        this.hasDetails = false;
        this.rating = undefined;

        this.notification = {
            ...this.notification,
            active: true,
            message: Yii.t('wui-iqbh-js', "Aucune information de l'hôtel n'a été trouvée")
        };
    }

    private initServices(booking: IGetBookingsStayResponse): void {
        //to be sure to show old bookings
        const services: IService[] = Array.isArray(booking.service) ? booking.service : [booking.service];
        (services || []).forEach((service: IService) => {
            if (service && service.mealplan) {
                this.services = {
                    mealplan: service
                };
            }
        });
    }

    private computeImportantInformations(booking: Partial<IGetBookingsStayResponse>): void {
        const hasBookingDescription: boolean = booking.property &&
            booking.property[0] &&
            booking.property[0].description?.length > 0;
        const hasQuoteDescription: boolean = Boolean(this.quote?.descriptions);
        this.canDisplayImportantInformationLink = hasBookingDescription ?
            this.propertyDescriptionService.isDisplayableDescription(...booking.property[0].description) :
            hasQuoteDescription ?
                this.propertyDescriptionService.isDisplayableDescription(...(this.quote.descriptions || [])) :
                false;
        if (this.canDisplayImportantInformationLink) {
            this.displayableDescriptions = booking.property[0].description.length > 0 ?
                booking.property[0].description :
                this.quote.descriptions;
        }
    }


    private getAccommodationsDetails(bookingArg: IGetBookingsStayResponse): IData[] {
        const booking: IGetBookingsStayResponse = _cloneDeep(bookingArg);

        const foundPrice: IPrice = booking.price.find((price: IPrice) => price.xTarget === 'total');
        const {base}: { base: IPriceDetail[] } = foundPrice && foundPrice.detail ? foundPrice.detail : {base: null};
        // @ts-ignore
        const supplementList: IPriceDetail[] = foundPrice && foundPrice.detail ?
            // @ts-ignore
            foundPrice.detail.supplement :
            null;
        //to be sure to show old bookings
        const accommodations: IAccommodation[] = Array.isArray(booking.accomodation) ? booking.accomodation : [booking.accomodation];
        return (accommodations || []).map((accommodation: IAccommodation): IData => {
            let room: IPriceDetail = base ? base.find((priceDetail: IPriceDetail) =>
                priceDetail.accomodation.some((accoXId: IXId) => accoXId.xId === accommodation.xId)
            ) : null;

            if (room) {
                const roomOnQuote: IHotelQuoteDetail = this.quote?.detail ? Object.values(this.quote.detail).find((hotelQuoteDetails: IHotelQuoteDetail): boolean =>
                    hotelQuoteDetails.room.xId === accommodation.xId
                ) : null; // WARNING : issue with async and permission => is checked on HTML
                const foundRetailPrice: IPrice = booking.price.find((price: IPrice) => price.xTarget === 'total' && price.xType === EXRateType.retail);

                const supplementLocal: IPriceDetail = extractSupplement(accommodation, supplementList, XSellLocationEnum.local, this.mainCurrency || room.currency);
                const supplementMerchant: IPriceDetail = extractSupplement(accommodation, supplementList, XSellLocationEnum.merchant, this.mainCurrency || room.currency);
                if(this.mainCurrency){
                    if(room.currency.toString() === this.mainCurrency){
                        room.amount = Number(room.amount) + Number(supplementMerchant?.amount ? supplementMerchant.amount : 0);
                        room.value = Number(room.value) + Number(supplementMerchant?.value ? supplementMerchant.value : 0);
                        if (room.originalCurrency) {
                            room.originalCurrency.amount = Number(room.originalCurrency.amount) + Number(supplementMerchant?.originalCurrency?.amount ? supplementMerchant.originalCurrency.amount : 0);
                            room.originalCurrency.value = Number(room.originalCurrency.value) + Number(supplementMerchant?.originalCurrency?.value ? supplementMerchant.originalCurrency.value : 0);
                        }
                    } else if (room.originalCurrency) {
                        const originalCurrency: IOriginalCurrency = _cloneDeep(room.originalCurrency);

                        const originalCurrencySupplementMerchant: IPriceDetail = extractSupplement(accommodation, supplementList, XSellLocationEnum.merchant, room.currency );
                        const priceRootSupplementMerchant: IPriceDetail = extractSupplement(accommodation, supplementList, XSellLocationEnum.merchant, this.mainCurrency );


                        room.originalCurrency.amount = Number(room.amount) + Number(originalCurrencySupplementMerchant?.amount ? originalCurrencySupplementMerchant.amount : 0);
                        room.originalCurrency.value = Number(room.value) + Number(originalCurrencySupplementMerchant?.value ? originalCurrencySupplementMerchant.value : 0);
                        room.originalCurrency.currency = room.currency;

                        room.amount = Number(originalCurrency.amount) + Number(priceRootSupplementMerchant?.amount ? priceRootSupplementMerchant.amount : 0);
                        room.value = Number(originalCurrency.value) + Number(priceRootSupplementMerchant?.value ? priceRootSupplementMerchant.value : 0);
                        room.currency = this.mainCurrency;
                    }
                }else{
                    if(supplementMerchant?.amount){
                        room.amount = Number(room.amount) + Number(supplementMerchant?.amount ? supplementMerchant.amount : 0);
                        room.value = Number(room.value) + Number(supplementMerchant?.value ? supplementMerchant.value : 0);
                        if (room.originalCurrency) {
                            room.originalCurrency.amount = Number(room.originalCurrency.amount) + Number(supplementMerchant?.originalCurrency?.amount ? supplementMerchant.originalCurrency.amount : 0);
                            room.originalCurrency.value = Number(room.originalCurrency.value) + Number(supplementMerchant?.originalCurrency?.value ? supplementMerchant.originalCurrency.value : 0);
                        }
                    }
                }
                if((roomOnQuote && roomOnQuote.unit.retail) || (foundRetailPrice)){
                    let retails: Array<[string, number]> = [];
                    if(roomOnQuote){
                        retails = Object.entries(roomOnQuote.unit.retail);
                    } else {
                        const priceRetailDetails: IPriceDetail[] = (foundRetailPrice.detail?.base || [])
                            .filter((priceDetail: IPriceDetail): boolean =>
                                priceDetail.accomodation.some((ac: IXId):boolean => ac.xId === accommodation.xId)
                            );
                        retails = priceRetailDetails.map((total: ITotal): [string, number] => ([total.currency, total.value]));
                    }
                    const supplement: IQuoteSupplement = Array.isArray(this.quote?.supplement) ? Object.values(this.quote?.supplement).find((quoteSupplement: IQuoteSupplement) =>
                        quoteSupplement.room === accommodation.xId) : this.quote?.supplement;

                    const supplementRetailList: IPriceDetail[] = foundRetailPrice && foundRetailPrice.detail ? foundRetailPrice.detail.supplement : null;
                    const supplementRetailMerchant: IPriceDetail = extractSupplement(accommodation, supplementRetailList, XSellLocationEnum.merchant, room.currency);

                    room = {
                        ...room,
                        retail: retails.map((element: [string, number]): ITotal => {
                            const amountToUse: number = roomOnQuote ?
                                (supplement?.total?.retail ? supplement.total.retail[element[0]] : 0) :
                                (supplementRetailMerchant?.amount ? supplementRetailMerchant.amount : 0);
                            const valueToUse: number = roomOnQuote ?
                                (supplement?.total?.retail ? supplement.total.retail[element[0]] : 0) :
                                (supplementRetailMerchant?.value ? supplementRetailMerchant.value : 0);

                            return {
                                amount: Number(element[1]) + Number(amountToUse),
                                value: Number(element[1]) + Number(valueToUse),
                                currency: element[0],
                                decimals: 2
                            };
                        })
                    };
                }

                const traveller: ITraveller[] = room.traveller
                    .map((roomTraveller: ITraveller) => {
                        return booking.traveller.find((person: ITraveller) => person.xId === roomTraveller.xId);
                    })
                    .filter((roomTraveller: ITraveller) => accommodation.traveller.some((travellerItem: IXId) => travellerItem.xId === roomTraveller.xId));


                return {
                    accommodation,
                    traveller,
                    room: {
                        ...room,
                        name: accommodation.name,
                        xCode: accommodation.xCode
                    },
                    supplement: {
                        ...supplementLocal,
                        name: accommodation.name,
                        xCode: accommodation.xCode
                    }
                };
            }

            this.errorTracingService.captureException(`The room: ${String(accommodation)} does not exist.`);

            return {accommodation};
        });
    }

    private setHostInformations(): IHostInformations {
        let hostName: string = null;
        let hostPropertySyscode: string = null;

        if (this.quotePropertyAlternatives && this.booking) {
            hostName = this.booking.host;
            hostPropertySyscode = this.quotePropertyAlternatives.find((alternative: IAlternative) => alternative.hostCode === hostName).syscode;
        } else if (this.quote && this.quote.hostCode && this.quote.syscode) {
            hostName = this.quote.hostCode;
            hostPropertySyscode = this.quote.syscode;
        } else if (this.sector && this.sector.host && this.sector.property && this.sector.property.xId) {
            hostName = this.sector.host;
            hostPropertySyscode = this.sector.property.xId;
        } else if (this.booking && this.booking.property && this.booking.property.length) {
            hostName = this.booking.host;
            hostPropertySyscode = this.booking.property[0].xId;
        }

        return {hostName, hostPropertySyscode};
    }


    private setPropertyFromResource(hostName: string, hostPropertySyscode: string): void {
        if (hostName && hostPropertySyscode) {
            this.getHostProperty(hostName, hostPropertySyscode).pipe(
                finalize(() => {
                    this.loader.active = false;
                })
            ).subscribe({
                next: (propertyResponse: IGetPropertyResponse): void => {
                    if (propertyResponse && propertyResponse.property) {
                        this.property = propertyResponse ? propertyResponse.property : null;
                        this.hasDetails = true;
                        this.rating = propertyResponse.property.rating &&
                        propertyResponse.property.rating.value &&
                        !isNaN(Number(propertyResponse.property.rating.value))
                            ? propertyResponse.property.rating.value : undefined;
                        this.onGetProperty.emit(propertyResponse.property);
                    } else {
                        this.property = null;
                        this.rating = undefined;
                        this.hasDetails = false;
                    }
                },
                error: (error: Error): void => {
                    this.errorTracingService.captureException(error);
                    this.displayErrorOnGetProperty(error);
                }
            });
        } else {
            this.displayErrorOnGetProperty(
                {message: Yii.t('wui-shared-js', 'Propriété inconnue'), name: 'Erreur'}
            );
        }
    }

    private getHostProperty(hostCode: string, propertySyscode: string): Observable<IGetPropertyResponse> {
        if (this.storedProperties && this.storedProperties[propertySyscode]) {
            return of({property: this.storedProperties[propertySyscode]});
        }
        return this.propertyResourceService.getHostProperty(hostCode, propertySyscode);
    }
}

// TODO : externalServices : issue with price that becomes higher everytime is here
export function createBasePriceByAccomodation(bookingArg: IGetBookingsStayResponse): { [key: string]: ICost } {
    const booking: IGetBookingsStayResponse = _cloneDeep(bookingArg);
    const allPrices: IPriceDetail[] = getAllPriceDetailsWithAccommodation(_cloneDeep(bookingArg));
    return (booking.accomodation || [])
        .map((accomodation: IAccommodation): [string, ICost] => {

            const priceDetailsForAccomodation: IPriceDetail[] = _cloneDeep(allPrices)
                .filter((basePrice: IPriceDetail) =>
                    basePrice.accomodation
                    && basePrice.accomodation.some((reference: IXId) => reference.xId === accomodation.xId));

            // TODO : externalServices : issue is actually right there
            const cost: ICost = priceDetailsForAccomodation.reduce((current: ICost, detail: IPriceDetail): ICost => {
                current[detail.currency] = 0;
                current[detail.currency] += _cloneDeep(detail.unitValue);
                return current;
            }, {});
            return [
                accomodation.xId,
                cost,
            ];
        })
        .reduce(indexByKeyReduce, {});
}

export function getAllPriceDetailsWithAccommodation(booking: IGetBookingsStayResponse): IPriceDetail[] {
    return (Object.values(_cloneDeep(booking).price) || [])
        .filter((price: IPrice) => price.xType === EXRateType.cost)
        .map((price: IPrice) => price.detail && price.detail.base)
        .reduce(flattenReduce, [])
        .filter((detail: IPriceDetail) => detail.accomodation);
}

function flattenReduce<T>(accumulator: T[], current: T[]): T[] {
    return [...(accumulator || []), ...(current || [])];
}

function indexByKeyReduce<T>(accumulator: { [key: string]: T }, [key, value]: [string, T]): { [key: string]: T } {
    return {
        ...(accumulator || {}),
        [key]: value
    };
}

export function extractSupplement(accommodation: IAccommodation, supplementListArg: IPriceDetail[], type: XSellLocationEnum, currency: string  ='EUR'): IPriceDetail {

    if (!supplementListArg) {
        return null;
    }
    const supplementList: IPriceDetail[] = !Array.isArray(supplementListArg) ? [supplementListArg] : supplementListArg;
    const foundedSupplement = supplementList.find((supplementItem: IPriceDetail): boolean => {

        return supplementItem.currency === currency &&
        Boolean(supplementItem?.accomodation) &&
            (Array.isArray(supplementItem.accomodation) ?
                supplementItem.accomodation :
                [supplementItem.accomodation]).some((accoXId: IXId): boolean => accoXId.xId === accommodation.xId) &&
            supplementItem.xSellLocation === type;
    });

    if(foundedSupplement){
        return {
            ...foundedSupplement,
            amount: foundedSupplement.amount ? Number(foundedSupplement.amount): 0,
            value: foundedSupplement.value ? Number(foundedSupplement.value): 0,
        }
    }

    return null;
}
